<template>
  <section qaid="summary-item" class="border-b border-gray-10 py-1">
    <h2 v-if="title" :id="titleId" class="text-xs text-gray-60 pb-1">
      {{ title }}
    </h2>
    <ul v-if="items && items.length">
      <li v-for="item in items" :key="item.name" :class="listClasses">
        <div class="flex justify-between">
          <div v-if="item.name" :class="nameClasses" qaid="summary-item-name">
            {{ item.name }}
          </div>
          <div v-if="item.price" qaid="summary-item-price" :class="priceClasses">
            {{ item.price }}
          </div>
        </div>
        <div v-if="item.choice" class="text-xs" qaid="summary-item-choice">
          {{ item.choice }}
        </div>
      </li>
    </ul>
    <slot name="list-item-content"></slot>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    isPriceSection: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    listClasses() {
      return this.isPriceSection ? 'pt-1 last:pb-1' : 'pb-2 last:pb-0';
    },
    nameClasses() {
      return this.isPriceSection ? 'text-md font-bold' : 'text-xs font-medium';
    },
    priceClasses() {
      return this.isPriceSection ? 'text-md font-medium' : 'text-xs';
    },
    titleId() {
      return `summary-item-title-${this.title?.replace(/\s+/g, '-').toLowerCase()}`;
    },
  },
};
</script>
